import { useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import "./css/forum.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faPaperPlane,
  faUser,
  faBookOpen,
  faSpinner,
  faMessage
} from "@fortawesome/free-solid-svg-icons";

function Forum() {
  const taskRef = useRef("");
  const [messages, setMessages] = useState([]);
  const [name, setName] = useState(localStorage.getItem("name") || "Student");
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [inputContent, setInputContent] = useState("");
  const location = useLocation();
  const courseId = location.pathname.split("/")[2];

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/discussions/${courseId}`)
      .then((res) => res.json())
      .then((data) => {
        setMessages(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching discussions:", err);
        setLoading(false);
      });

    fetch(`${API_BASE_URL}/api/courses/${courseId}`)
      .then((res) => res.json())
      .then((data) => setCourse(data))
      .catch((err) => console.error("Error fetching course details:", err));
  }, [courseId]);

  const addTask = () => {
    if (inputContent.trim() !== "") {
      const payload = {
        name: name,
        uName: name,
        course_id: courseId,
        content: inputContent.trim()
      };

      fetch(`${API_BASE_URL}/api/discussions/addMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then((res) => res.json())
        .then((savedMsg) => {
          setMessages((prev) => [...prev, savedMsg || payload]);
          setInputContent("");
        })
        .catch(() => {
          setMessages((prev) => [...prev, payload]);
          setInputContent("");
        });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      addTask();
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#f8fafc" }}>
      <Navbar page={"courses"} />

      {/* Forum Header Banner */}
      <div className="page-banner" style={{ padding: "56px 6% 48px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(255,255,255,0.1)", padding: "6px 16px", borderRadius: "20px", fontSize: "0.85rem", marginBottom: "16px" }}>
          <FontAwesomeIcon icon={faBookOpen} style={{ color: "#a5b4fc" }} />
          Course Discussion Thread
        </div>
        <h1>{course?.course_name || course?.courseName || "Course Discussion Forum"}</h1>
        <p>Connect, ask questions, and collaborate with fellow enrolled students and instructors.</p>
      </div>

      {/* Discussion Main Container */}
      <div style={{ flex: 1, padding: "40px 6% 80px", maxWidth: "960px", margin: "0 auto", width: "100%" }}>
        {/* Chat Thread Card */}
        <div className="forum-chat-card">
          <div className="forum-chat-header">
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FontAwesomeIcon icon={faComments} style={{ color: "#4f46e5", fontSize: "1.3rem" }} />
              <h3 style={{ margin: 0, fontSize: "1.15rem", fontWeight: 700, color: "#0f172a" }}>
                Class Discussion
              </h3>
            </div>
            <span className="discussion-count-badge">
              {messages.length} {messages.length === 1 ? "Message" : "Messages"}
            </span>
          </div>

          {/* Messages Container */}
          <div className="forum-messages-container">
            {loading ? (
              <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
                <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "2rem", color: "#4f46e5", marginBottom: "12px" }} />
                <p>Loading messages...</p>
              </div>
            ) : messages.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 0", color: "#64748b" }}>
                <FontAwesomeIcon icon={faMessage} style={{ fontSize: "2.5rem", color: "#cbd5e1", marginBottom: "14px" }} />
                <h4 style={{ color: "#0f172a", marginBottom: "4px" }}>No messages yet</h4>
                <p>Be the first to start the discussion for this course!</p>
              </div>
            ) : (
              messages.map((val, idx) => {
                if (!val.content || !val.content.trim()) return null;
                const author = val.uName || val.name || "Student";
                const initial = author.charAt(0).toUpperCase();

                return (
                  <div key={idx} className="forum-message-bubble">
                    <div className="forum-user-avatar">{initial}</div>
                    <div className="forum-message-content">
                      <div className="forum-author-name">{author}</div>
                      <div className="forum-message-text">{val.content}</div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Input Box Card */}
          <div className="forum-input-section">
            <div style={{ position: "relative" }}>
              <textarea
                rows="3"
                placeholder="Share your thoughts or ask a question about this course... (Press Enter to send)"
                value={inputContent}
                onChange={(e) => setInputContent(e.target.value)}
                onKeyDown={handleKeyPress}
                className="forum-textarea"
              />
              <button onClick={addTask} className="forum-send-btn">
                <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: "6px" }} />
                Send
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Forum;
